export default {
  auto: 'Automatyczny',
  signals: 'Sygnały',
  axes: 'Siekiery',
  axesHeader: {
    displayName: 'Etykieta osi',
    chartScaleType: 'Typ osi',
    position: 'Pozycja osi',
    limitMin: 'Limit minimalny',
    limitMax: 'Maksymalny limit',
    defaultUnitOfMeasure: 'Jednostka miary',
    signalCount: 'Liczba sygnałów',
    delete: '',
  },
  deleteAxisConfirmation: {
    title: 'Usuń oś',
    message: 'Ta oś zawiera {count} sygnałów. Wszystkie te sygnały również zostaną usunięte. Czy na pewno chcesz je Usunąć?',
  },
};
